<template>
    <div
        class="apprentice-simple-card"
        v-if="loaded">
        <b-button
            class="btn-add"
            v-b-modal="'calendar-add-calendar-item'"
            variant="primary">
            {{ $t('calendar.new_appointment') }}
        </b-button>

        <design-2021-calendar-add-calendar-item-modal-component
            @create-agenda-item="createAgendaItem($event)"></design-2021-calendar-add-calendar-item-modal-component>

        <design-2021-calendar-settings-modal-component
            :ref="'calendar-item-settings-modal'"
            @update-item="updateCalendarItem"
            @delete-item="deleteCalendarItem"
            :item-in="selectedItem"></design-2021-calendar-settings-modal-component>

        <design-2021-calendar-update-calendar-item-modal-component
            :ref="'calendar-update-calendar-item'"
            :item-in="selectedItem"
            @update-calendar-item="
                updateToDatabase($event)
            "></design-2021-calendar-update-calendar-item-modal-component>

        <design-2021-apprentice-fullcalendar-component
            ref="calendar"
            :url="true"
            :calendar-items-in="calendarItems"
            :types="['listYear', 'dayGridWeek', 'dayGridMonth']"
            :right-buttons="true"
            :emit-changed-date="true"
            @update-item="settingsAgendaItem($event)"
            @change-date="changeDate($event)"></design-2021-apprentice-fullcalendar-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-calendar-index-component',
    props: {
        calendarItemsIn: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            calendarItems: this.getCalendarItems(),
            selectedItem: {},
            loaded: false,
            loadedWeeks: [],
            calendarView: '',
            init: true,
        };
    },
    methods: {
        changeDate(data) {
            if (this.init) {
                if (localStorage.getItem('calendarView') && this.init) {
                    this.$refs.calendar.$refs.fullCalendar.calendar.changeView(localStorage.getItem('calendarView'));
                    this.init = false;
                }
            }

            localStorage.setItem('calendarView', data.view);
        },

        getCalendarItems() {
            if (this.calendarItemsIn && this.calendarItemsIn.length > 0) {
                return this.calendarItemsIn.map((item) => {
                    let color = '';

                    switch (item.type_id) {
                        // 1 = logboek
                        case 1:
                            color = 'blue';
                            break;
                        // 2 = planning
                        case 2:
                            color = 'orange';
                            break;
                        // 3 = deadline
                        case 3:
                            color = 'red';
                            break;
                        default:
                            color = 'orange';
                    }

                    if (item.model_type === 'App\\Models\\User') {
                        color = 'green';
                    }

                    let start;
                    let end = null;

                    if (item.time) {
                        start = item.date_time;
                    } else {
                        start = item.date;
                    }
                    if (item.date_time_end_date) {
                        end = item.date_time_end_date;
                    } else {
                        end = start;
                    }

                    return {
                        id: item.id,
                        title: item.title,
                        date: item.date,
                        redirect: item.url,
                        created_by: item.created_by,
                        date_end: item.date_end,
                        date_time: item.date_time,
                        date_time_end_date: item.date_time_end_date,
                        description: item.description,
                        location: item.location,
                        time: item.time,
                        time_end: item.time_end,
                        color: color,
                        start: start,
                        end: end,
                        type: 'calendar',
                        model_type: item.model_type,
                    };
                });
            }

            return [];
        },

        createAgendaItem(item) {
            this.alert.saving();

            this.axios.post(this.routes.calendarAdd(), item).then(
                (response) => {
                    let start;
                    let end = null;
                    if (item.time) {
                        start = response.data.date_time;
                    } else {
                        start = response.data.date;
                    }
                    if (item.date_time_end_date) {
                        end = response.data.date_time_end_date;
                    } else {
                        end = start;
                    }
                    let newItem = {
                        id: response.data.id,
                        title: response.data.title,
                        date: response.data.date,
                        redirect: null,
                        created_by: response.data.created_by,
                        date_end: response.data.date_end,
                        date_time: response.data.date_time,
                        date_time_end_date: response.data.date_time_end_date,
                        description: response.data.description,
                        full_date_time: response.data.full_date_time,
                        location: response.data.location,
                        time: response.data.time,
                        time_end: response.data.time_end,
                        color: 'green',
                        start: start,
                        end: end,
                        type: 'calendar',
                        model_type: response.data.model_type,
                        // fulldate: response.data.fulldate,
                        // longdate: response.data.longdate,
                        // model_id: response.data.model_id,
                        // reflection: response.data.reflection,
                        // remark: response.data.remark,
                        // remark_visible: response.data.remark_visible,
                        // shortdate: response.data.shortdate,
                        // shorttime: response.data.shorttime,
                        // created_at: response.data.created_at,
                        // updated_at: response.data.updated_at,
                        // difference: response.data.difference,
                        // assignment_id: null,
                        // group_name: null,
                        // project_id: null,
                        // project_name: null,
                        // sub_assignment_id: null,
                        // type_id: null,
                        // type_name: null,
                        // url: ''
                    };

                    this.calendarItems.push(newItem);

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        settingsAgendaItem(item) {
            this.calendarItems.forEach((calendarItem) => {
                if (calendarItem.id === Number(item.id)) {
                    this.selectedItem = calendarItem;
                }
            });

            this.$refs['calendar-item-settings-modal'].show();
        },

        updateCalendarItem() {
            this.$refs['calendar-update-calendar-item'].show();
        },

        updateToDatabase(item) {
            this.alert.saving();

            this.axios.post(this.routes.calendarUpdate(this.selectedItem.id), item).then(
                (response) => {
                    this.calendarItems = this.calendarItems.map((calendarItem) => {
                        if (calendarItem.id === this.selectedItem.id) {
                            return response.data;
                        } else {
                            return calendarItem;
                        }
                    });

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        deleteCalendarItem() {
            this.alert
                .confirm(
                    this.$t('calendar.delete_event_confirmation_title'),
                    this.$t('calendar.delete_event_confirmation_body'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.calendarDelete(this.selectedItem.id)).then(
                            (response) => {
                                this.alert.success();

                                this.calendarItems = this.calendarItems.filter(
                                    (calendarItem) => calendarItem.id !== this.selectedItem.id,
                                );
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
    mounted() {
        // TODO: Can this (and the whole calendar view) be removed, as Zermelo is removed?
        if (!this.loaded) {
            this.loaded = true;

            this.$nextTick(() => {
                if (localStorage.getItem('calendarView') && this.loaded && this.$refs.calendar) {
                    this.$refs.calendar.$refs.fullCalendar.calendar.changeView(localStorage.getItem('calendarView'));
                    this.init = false;
                }
            });
        }
    },
};
</script>

<style scoped lang="scss"></style>
